import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Lock, ArrowLeft, ShieldCheck } from "lucide-react";

export default function TopicDetail() {
  const { slug } = useParams();
  const [topic, setTopic] = useState(null);
  const nav = useNavigate();

  useEffect(() => {
    api.get(`/library/topic/${slug}`).then(r => setTopic(r.data.topic));
  }, [slug]);

  if (!topic) return <div className="py-10 text-center text-slate-500">Loading…</div>;

  return (
    <article className="max-w-3xl mx-auto" data-testid="topic-detail">
      <button onClick={()=>nav(-1)} className="text-sm text-slate-500 inline-flex items-center gap-1 mb-4"><ArrowLeft className="h-4 w-4" /> Back</button>
      <div className="text-xs uppercase tracking-widest text-slate-500">{topic.category_slug || topic.qualification}</div>
      <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">{topic.title}</h1>
      <p className="mt-2 text-slate-600 dark:text-slate-400">{topic.summary}</p>

      {topic.locked ? (
        <div className="mt-8 rounded-2xl border border-amber-500/40 bg-amber-500/10 p-8 text-center">
          <Lock className="h-8 w-8 text-amber-500 mx-auto" />
          <h3 className="mt-3 text-xl font-bold">Premium content</h3>
          <p className="mt-1 text-slate-600 dark:text-slate-400">Upgrade to unlock this topic and 40+ more premium articles.</p>
          <Link to="/subscription" data-testid="topic-upgrade-btn" className="btn-accent mt-4">Upgrade to Premium</Link>
        </div>
      ) : (
        <div className="prose prose-slate dark:prose-invert mt-8 max-w-none">
          <pre className="whitespace-pre-wrap font-sans text-base leading-relaxed bg-transparent p-0 border-0">{topic.content}</pre>
        </div>
      )}
    </article>
  );
}
